export const connectTicketsToCallsModalSelectors = {
  container: 'connect-tickets-to-calls-modal',
  submitButton: 'connect-tickets-to-calls-modal-submit-button',
  cancelButton: 'connect-tickets-to-calls-modal-cancel-button'
};
